<template>
  <div>
      <topTab :changeTabIndex='0'></topTab>
      <h5page></h5page>    
      <bottomMsg></bottomMsg>
  </div>
</template>

<script>
// @ is an alias to /src
import h5page from "@/components/h5/h5.vue"
import bottomMsg from "@/components/bottomMsg/bottomMsg.vue"
import topTab from "@/components/topTab/topTab.vue"
export default {
  name: 'h5',
  components: {
    h5page,
    bottomMsg,
    topTab
  }
}
</script>
